import React from 'react';

const PauseIcon = () => (
  <svg
    width="23"
    height="25"
    viewBox="0 0 23 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1152 2.5V22.5C22.1152 23.0304 21.9045 23.5391 21.5294 23.9142C21.1544 24.2893 20.6457 24.5 20.1152 24.5H15.1152C14.5848 24.5 14.0761 24.2893 13.701 23.9142C13.3259 23.5391 13.1152 23.0304 13.1152 22.5V2.5C13.1152 1.96957 13.3259 1.46086 13.701 1.08579C14.0761 0.710714 14.5848 0.5 15.1152 0.5H20.1152C20.6457 0.5 21.1544 0.710714 21.5294 1.08579C21.9045 1.46086 22.1152 1.96957 22.1152 2.5ZM7.11523 0.5H2.11523C1.5848 0.5 1.07609 0.710714 0.701021 1.08579C0.325948 1.46086 0.115234 1.96957 0.115234 2.5V22.5C0.115234 23.0304 0.325948 23.5391 0.701021 23.9142C1.07609 24.2893 1.5848 24.5 2.11523 24.5H7.11523C7.64567 24.5 8.15438 24.2893 8.52945 23.9142C8.90452 23.5391 9.11523 23.0304 9.11523 22.5V2.5C9.11523 1.96957 8.90452 1.46086 8.52945 1.08579C8.15438 0.710714 7.64567 0.5 7.11523 0.5Z"
      fill="white"
    />
  </svg>
);

export default PauseIcon;
